import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import { Outlet } from "react-router-dom";
import FirstMileDrawer from './FreelanceDriverDrawer';
import FirstMileAppBar from './FreelanceDriverAppBar';
import { useMediaQuery } from '@mui/material';
import { useSocket } from 'src/_contexts/socket';
import { getCurrentUserProfile } from "src/_store/entities/profile";
import { useDispatch } from 'react-redux';

export default function ClippedDrawer() {
    const dispatch = useDispatch();
    const downLg = useMediaQuery(theme => theme.breakpoints.down('lg'));
    const [openDrawer, setOpenDrawer] = useState(false)
    const toggleDrawerHandler = () => {
        setOpenDrawer((prevState) => !prevState)
    }

    const { socket } = useSocket();

    const refetchProfileAccount = (data) => {
        if (["ACCOUNT_ACTIVATED"].includes(data.type)) {
            dispatch(getCurrentUserProfile())
        }
    }

    useEffect(_ => {
        if (socket) {
            socket.on("notification", refetchProfileAccount);
        }
        return _ => socket && socket.off('notification', refetchProfileAccount);
    }, [socket])

    return (
        <Box sx={{ display: downLg ? '' : 'flex' }}>
            <CssBaseline />
            <FirstMileAppBar toggleDrawer={toggleDrawerHandler} />
            <FirstMileDrawer openDrawer={openDrawer} toggleDrawer={toggleDrawerHandler} />
            {/* minWidth: 0 lets <main> shrink to the space beside the drawer; without it wide tables/tab rows
                push the page past the viewport, where html's overflow-x: hidden makes it unreachable */}
            <Box component="main" sx={{ flexGrow: 1, minWidth: 0, p: 3 }}>
                <Toolbar />
                <Outlet />
            </Box>
        </Box>
    );
}